
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustStrip from './components/TrustStrip';
import ProductsSection from './components/ProductsSection';
import AboutSection from './components/AboutSection';
import ProductRangeSection from './components/ProductRangeSection';
import TechnologySection from './components/TechnologySection';
import FAQSection from './components/FAQSection';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <ProductsSection />
        <TechnologySection />
        <AboutSection />
        <ProductRangeSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
